// Mock data for Alrehlah travel booking website

export const departureCities = [
  { id: 1, name: 'اب', code: 'اب' },
  { id: 2, name: 'ابها', code: 'ابها' },
  { id: 3, name: 'عدن', code: 'عدن' },
  { id: 4, name: 'صنعا', code: 'صنعا' },
  { id: 5, name: 'تعز', code: 'تعز' },
  { id: 6, name: 'الحديدة', code: 'الحديدة' },
  { id: 7, name: 'مأرب', code: 'مأرب' },
  { id: 8, name: 'المكلا', code: 'المكلا' },
  { id: 9, name: 'جدة', code: 'جدة' },
  { id: 10, name: 'الرياض', code: 'الرياض' },
  { id: 11, name: 'مكة المكرمة', code: 'مكة المكرمة' },
  { id: 12, name: 'المدينة المنورة', code: 'المدينة المنورة' },
  { id: 13, name: 'دبي', code: 'دبي' },
  { id: 14, name: 'الدمام', code: 'الدمام' },
];

export const arrivalCities = [
  { id: 1, name: 'عدن', code: 'عدن' },
  { id: 2, name: 'صنعا', code: 'صنعا' },
  { id: 3, name: 'جدة', code: 'جدة' },
  { id: 4, name: 'الرياض', code: 'الرياض' },
  { id: 5, name: 'مكة المكرمة', code: 'مكة المكرمة' },
  { id: 6, name: 'دبي', code: 'دبي' },
  { id: 7, name: 'المدينة المنورة', code: 'المدينة المنورة' },
  { id: 8, name: 'تعز', code: 'تعز' },
];

export const airports = [
  { id: 1, name: 'عدن', code: 'ADE' },
  { id: 2, name: 'صنعاء', code: 'SAH' },
  { id: 3, name: 'سيئون', code: 'GXF' },
  { id: 4, name: 'المكلا', code: 'RIY' },
  { id: 5, name: 'الغيضة', code: 'AAY' },
  { id: 6, name: 'سقطرى', code: 'SCT' },
  { id: 7, name: 'جدة', code: 'JED' },
  { id: 8, name: 'الرياض', code: 'RUH' },
  { id: 9, name: 'دبي', code: 'DXB' },
  { id: 10, name: 'القاهرة', code: 'CAI' },
  { id: 11, name: 'عمان', code: 'AMM' },
  { id: 12, name: 'جيبوتي', code: 'JIB' },
  { id: 13, name: 'أديس أبابا', code: 'ADD' },
  { id: 14, name: 'الكويت', code: 'KWI' },
  { id: 15, name: 'مومباي', code: 'BOM' },
];

export const hotelCities = [
  { id: 1, name: 'جميع المدن', value: 'all' },
  { id: 2, name: 'عدن', value: 'عدن' },
  { id: 3, name: 'مكة المكرمة', value: 'مكة المكرمة' },
];

export const countries = [
  { id: 1, name: 'جميع الدول', value: 'all' },
  { id: 2, name: 'الجمهورية اليمنية', value: 'yemen' },
  { id: 3, name: 'المملكة العربية السعودية', value: 'saudi' },
];

export const visaCountries = [
  { id: 1, name: 'أثيوبيا', value: 'ethiopia' },
  { id: 2, name: 'الأردن', value: 'jordan' },
  { id: 3, name: 'الامارات', value: 'uae' },
  { id: 4, name: 'السعودية', value: 'saudi' },
  { id: 5, name: 'الصين', value: 'china' },
  { id: 6, name: 'الهند', value: 'india' },
  { id: 7, name: 'إندونيسيا', value: 'indonesia' },
  { id: 8, name: 'تايلاند', value: 'thailand' },
  { id: 9, name: 'دول شنجن', value: 'schengen' },
  { id: 10, name: 'سلطنة عُمان', value: 'oman' },
  { id: 11, name: 'سنغافورة', value: 'singapore' },
  { id: 12, name: 'قطر', value: 'qatar' },
  { id: 13, name: 'كينيا', value: 'kenya' },
  { id: 14, name: 'مصر', value: 'egypt' },
];

export const popularHotels = [
  {
    id: 1,
    city: 'عدن',
    country: 'الجمهورية اليمنية',
    hotelsCount: 3,
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop'
  },
  {
    id: 2,
    city: 'مكة المكرمة',
    country: 'المملكة العربية السعودية',
    hotelsCount: 2,
    image: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=400&h=300&fit=crop'
  }
];

export const visaDestinations = [
  {
    id: 1,
    country: 'إندونيسيا',
    flag: '🇮🇩',
    visaTypes: 7,
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400&h=300&fit=crop'
  },
  {
    id: 2,
    country: 'مصر',
    flag: '🇪🇬',
    visaTypes: 4,
    image: 'https://images.unsplash.com/photo-1539650116574-8efeb43e2750?w=400&h=300&fit=crop'
  },
  {
    id: 3,
    country: 'الأردن',
    flag: '🇯🇴',
    visaTypes: 4,
    image: 'https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=400&h=300&fit=crop'
  },
  {
    id: 4,
    country: 'سلطنة عُمان',
    flag: '🇴🇲',
    visaTypes: 4,
    image: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?w=400&h=300&fit=crop'
  },
  {
    id: 5,
    country: 'الامارات',
    flag: '🇦🇪',
    visaTypes: 2,
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&h=300&fit=crop'
  },
  {
    id: 6,
    country: 'الصين',
    flag: '🇨🇳',
    visaTypes: 2,
    image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=400&h=300&fit=crop'
  },
  {
    id: 7,
    country: 'سنغافورة',
    flag: '🇸🇬',
    visaTypes: 1,
    image: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400&h=300&fit=crop'
  },
  {
    id: 8,
    country: 'أثيوبيا',
    flag: '🇪🇹',
    visaTypes: 1,
    image: 'https://images.unsplash.com/photo-1523805009345-7448845a9e53?w=400&h=300&fit=crop'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: 'search',
    title: 'حجز فوري',
    description: 'ابحث واحجز في اللحظة نفسها.'
  },
  {
    id: 2,
    icon: 'shield',
    title: 'آمن وموثوق',
    description: 'تحويلات آمنة مع معاملات مشفرة وشركاء سفر موثوقين',
    badge: 'تحويلات آمنة'
  },
  {
    id: 3,
    icon: 'headphones',
    title: 'دعم على مدار الساعة',
    description: 'دائماً متاحين لمساعدتك',
    badge: 'دائماً متاح'
  },
  {
    id: 4,
    icon: 'tag',
    title: 'السعر الأفضل',
    description: 'تقديرات منافسة وعروض خاصة من شبكة شركاتنا العالمية',
    badge: 'ضمان تطابق الأسعار'
  }
];

export const tripTypes = [
  { id: 1, name: 'جميع الأنواع', value: 'all' },
  { id: 2, name: 'سياحية', value: 'tourism' },
  { id: 3, name: 'الدرجة التجارية', value: 'business' },
  { id: 4, name: 'طالب', value: 'student' },
  { id: 5, name: 'عمل', value: 'work' },
];

export const flightClasses = [
  { id: 1, name: 'الدرجة الاقتصادية', value: 'economy' },
  { id: 2, name: 'الدرجة التجارية', value: 'business' },
  { id: 3, name: 'الدرجة الأولى', value: 'first' },
];

export const fareGroups = [
  { id: 1, name: 'العادي', value: 'regular' },
  { id: 2, name: 'الأساسي', value: 'basic' },
  { id: 3, name: 'مرن', value: 'flex' },
  { id: 4, name: 'بريميوم', value: 'premium' },
];

export const passengerCounts = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export const luggageCounts = [0, 1, 2, 3, 4, 5];
export const adultCounts = [1, 2, 3, 4];
export const childCounts = [0, 1, 2, 3];
export const infantCounts = [0, 1, 2];
export const starRatings = [1, 2, 3, 4, 5];
